// eslint-disable-next-line import/no-unresolved
import Swiper from 'swiper/bundle';

const swipers = [];

document.querySelectorAll('.swiper-pdp-content-carousel')?.forEach(
  (slider) => {
    swipers.push(new Swiper(slider, JSON.parse(slider.getAttribute('data-slider-settings'))));
  },
);

// eslint-disable-next-line no-console
// console.log(`Initialised ${swipers.length} pdp carousel swipers`, swipers);
